import { render, staticRenderFns } from "./StatisticsCards.vue?vue&type=template&id=270bd00e&scoped=true"
import script from "./StatisticsCards.vue?vue&type=script&lang=js"
export * from "./StatisticsCards.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCards.vue?vue&type=style&index=0&id=270bd00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bd00e",
  null
  
)

export default component.exports